
import vue from '../adapter-vue';
import imRobotGuess from '../assets/imRobotGuess.svg';
import refresh from '../assets/refresh.svg';
import iconRight from '../assets/iconRight.svg';
import Icon from './customer-icon.vue';
import { customerServicePayloadType } from '../interface';

const { reactive, toRefs } = vue;

interface Props {
  payload: customerServicePayloadType;
}

interface welcomeBranchItem {
  id: string;
  content: string;
  answer: string;
}

export default {
  components: {
    Icon,
  },
  props: {
    payload: {
      type: Object as () => customerServicePayloadType,
      default: () => ({ content: { title: '', items: [] } }),
    },
  },
  emits: ['sendMessage'],
  setup(props: Props, { emit }) {
    const data = reactive({
      // title
      title: props.payload?.content?.title || '',
      // all branch list
      list: props.payload?.content?.items || [],
      // current branch list
      showList: (props.payload?.content?.items || []).slice(0, 5),
      // current page number
      pageNumber: 1,
    });

    const handleContentListItemClick = (branch: welcomeBranchItem) => {
      emit('sendMessage', { text: branch.content });
    };

    const changeBranchList = () => {
      if (data.pageNumber * 5 >= data.list?.length) {
        data.pageNumber = 0;
      }
      data.showList = data.list?.slice(
        data.pageNumber * 5,
        data.pageNumber * 5 + 5,
      );
      data.pageNumber += 1;
    };

    return {
      ...toRefs(data),
      handleContentListItemClick,
      imRobotGuess,
      refresh,
      iconRight,
      changeBranchList,
    };
  },
};
